(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Chrome, loading="lazy" gorselleri viewport'a ~1250px kala indirmeye baslar.
   * Hizli scroll'da bu mesafe yetmedigi icin kart arka plani (beyaz) gorunur.
   * Asagidaki gozlemci, kart viewport'a 2000px kala loading'i eager'a cevirerek
   * indirmeyi erken tetikler. Native lazy fallback olarak korunur.
   */
  (() => {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const img = entry.target;
          observer.unobserve(img);
          if (img.loading === 'lazy') img.loading = 'eager';
        }
      },
      { rootMargin: '2000px 0px' }
    );

    const observe = (root) => {
      root.querySelectorAll('img.variant-card__image[loading="lazy"]').forEach((img) => {
        observer.observe(img);
      });
    };

    const start = () => {
      observe(document);
      // Infinite scroll ile eklenen kartlari da yakala.
      const grid = document.querySelector('.product-grid');
      if (!grid) return;
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (node.nodeType === 1) observe(node);
          }
        }
      }).observe(grid, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
